export default {
	updateDialog: {
		updated: 'Eine neue Version wurde geladen.',
	},
}
